import { UPDATE_USERS_TO_INACTIVE_ERROR, UPDATE_USERS_TO_INACTIVE_SUCCESS, UPDATE_USERS_TO_INACTIVE_POST_ERROR } from "../actions/types";

export default (state = { error: "", success: "", isSwitchSnackbarOn: false }, action) => {
    switch (action.type) {
        case UPDATE_USERS_TO_INACTIVE_ERROR:
            return {
                ...state,
                error: action.payload,
                success: state.success,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'User deactivate fail',
                key: action.key,
            };
        case UPDATE_USERS_TO_INACTIVE_SUCCESS:
            return {
                ...state,
                error: state.error,
                success: action.payload,
                isSnackbarError: false,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'User deactivate successful',
                key: action.key,
            };
        case UPDATE_USERS_TO_INACTIVE_POST_ERROR:
            return {
                ...state,
                error: state.error,
                success: action.payload,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: 'Operation Error, please contact administrator.',
                key: action.key,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/updateUsersToInactiveReducer.js